import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { deleteTrackingReport } from '@/features/projects/kpi-tracking-entry/api/delete-tracking-report';
import { invalidateTrackingReportQueries } from '@/features/projects/kpi-tracking-entry/hooks/use-tracking-reports';

type Props = Omit<
  UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrackingReport>>,
    unknown,
    number
  >,
  'mutationFn'
>;

export const useDeleteTrackingReport = (props?: Props) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...props,
    mutationFn: async (commentId) => {
      return deleteTrackingReport(commentId);
    },
    onSuccess: (data) => {
      invalidateTrackingReportQueries(queryClient, data.project_id);
    },
  });
};
